import types from "../actions/types";
const initialState = {};

export function fetchQlink(state = initialState, action) {
    switch (action.type) {
        case types.QLINK_FETCH_REQUEST:
            return { ...state, loading: true, error: false };
        case types.QLINK_FETCH_SUCCESS:
            return { qlinkObj: action.qlinkObj, loading: false, error: false };
        case types.QLINK_FETCH_ERROR:
            return { ...state, errorMsg: action?.status, qlinkObj: null, loading: false, error: true };
        case types.QLINK_FETCH_RESET:
                  return initialState;
        default:
            return state;
    }
  }

export function publishQlink(state = initialState, action) {
  switch (action.type) {
      case types.QLINK_PUBLISH_REQUEST:
          return { ...state, loading: true, error: false };
      case types.QLINK_PUBLISH_SUCCESS:
          return { publishedQlinkObj: action.publishedQlinkObj, loading: false, error: false };
      case types.QLINK_PUBLISH_ERROR:
          return { ...state, errorMsg: action?.status, publishedQlinkObj: null, loading: false, error: true };
      case types.QLINK_PUBLISH_RESET:
                return initialState;
      default:
          return state;
  }
}

export function revokeQlink(state = initialState, action) {
    switch (action.type) {
        case types.QLINK_REVOKE_REQUEST:
            return { ...state, loading: true, error: false };
        case types.QLINK_REVOKE_SUCCESS:
            return { revokedQlinkObj: action.revokedQlinkObj, loading: false, error: false };
        case types.QLINK_REVOKE_ERROR:
            return { ...state, errorMsg: action?.status, revokedQlinkObj: null, loading: false, error: true };
        case types.QLINK_REVOKE_RESET:
                return initialState;
        default:
            return state;
    }
  }